import { StyledButton } from './StyledComponents';

import '../styles/Snackbar.css';

const Snackbar = ({ snackbarText, setOpenSnackbar }) => {
    return (
        <>
            <div className="snackbarBackground" onClick={() => setOpenSnackbar(false)}>
            </div>

            <div className="snackbarContainer">
                <div className="snackbarContent">
                    <div className="snackbarText">
                        {snackbarText}
                    </div>
                    <StyledButton className="snackbarButton" onClick={() => setOpenSnackbar(false)}>
                        Aceptar
                    </StyledButton>
                </div>
            </div>
        </>
    )
};

export default Snackbar